import React from 'react';
import {BellIcon} from '@heroicons/react/24/outline';
import {BellIcon as BellIconSolid} from '@heroicons/react/24/solid';

interface NotificationBellProps {
  unreadCount: number;
  isActive?: boolean;
  className?: string;
}

export function NotificationBell({ unreadCount, isActive, className = '' }: NotificationBellProps) {
  const Icon = isActive ? BellIconSolid : BellIcon;

  return (
    <div className={`relative ${className}`}>
      <Icon className="h-6 w-6" />
      {unreadCount > 0 && (
        <span
          className="absolute -top-1.5 -right-1.5 flex h-4 min-w-4 items-center
            justify-center rounded-full bg-primary px-1 text-xs  text-on-brand"
        >
          {unreadCount > 99 ? '99+' : unreadCount}
        </span>
      )}
    </div>
  );
}
